var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#424b54","fillRule":"evenodd","d":"M9.72,4.9v.45A4.38,4.38,0,1,1,5.35,1a4.33,4.33,0,0,1,1.77.38.49.49,0,0,0,.65-.25A.48.48,0,0,0,7.52.46,5.35,5.35,0,0,0,0,5.35a5.35,5.35,0,0,0,10.69,0V4.9a.49.49,0,0,0-1,0Z","key":0}),React.createElement("path",{"fillRule":"evenodd","fill":"#04a777","d":"M9.86,1.12,5.35,5.64,4.23,4.52a.49.49,0,0,0-.69.69L5,6.67a.5.5,0,0,0,.35.14.49.49,0,0,0,.34-.14L10.55,1.8a.48.48,0,0,0,0-.68.49.49,0,0,0-.69,0Z","key":1})]);
}

Check.defaultProps = {"viewBox":"0 0 10.69 10.69"};

module.exports = Check;

Check.default = Check;
